import * as React from 'react';

import MaskedInput from 'react-text-mask';

import { getPhoneMask, getCleanPhone, noop } from '@utils';

import { Input } from '../Input';

import { IPhoneInputProps } from './types';

class PhoneInputWithoutRef extends React.PureComponent<IPhoneInputProps> {

	static defaultProps: Partial<IPhoneInputProps> = {
		onChange: noop,
	};

	getMask = () => (value: string) => getPhoneMask(value);

	onChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
		const { onChange } = this.props;
		const { target: { value } } = evt;
		// correction for those users from Russia who start to print from 89
		const phoneNumber = value
			.replace(new RegExp('^\\+8(\\s\\(9.*)$'), '+7$1');

		onChange(phoneNumber, getCleanPhone(phoneNumber));
	};

	render() {
		const {
			innerRef,
			autoFocus,
			error,
			label,
			placeholder,
			description,
			name,
			value,
			rightElement,
			dataAttributes,
			guide,
			keepCharPositions,
			showMask,
			pipe,
			placeholderChar,
			isValid,
			isDisabled,
			onBlur,
			onFocus,
			onKeyDown,
			onKeyUp,
		} = this.props;

		return (
			<Input
				ref={innerRef}
				autoFocus={autoFocus}
				type="tel"
				autocomplete="tel"
				error={error}
				label={label}
				placeholder={placeholder}
				description={description}
				onChange={this.onChange}
				onBlur={onBlur}
				onFocus={onFocus}
				onKeyDown={onKeyDown}
				onKeyUp={onKeyUp}
				name={name}
				value={value}
				disabled={isDisabled}
				rightElement={rightElement}
				mask={this.getMask()}
				showMask={showMask}
				guide={guide}
				keepCharPositions={keepCharPositions}
				placeholderChar={placeholderChar}
				pipe={pipe}
				dataAttributes={dataAttributes}
				isValid={isValid}
			/>
		);
	}

}

export const PhoneInput = React.forwardRef(
	(props: IPhoneInputProps, ref: React.RefObject<MaskedInput>) => (
		<PhoneInputWithoutRef innerRef={ref} {...props} />
	),
);
